module.exports = __webpack_public_path__ + "static/media/HP-DeskJet-2320.fb972afa.jpg";